/**
 * Facility switcher routes (V6). Both in src/aithora/router.ts beside GET /organizations.
 * Names and places only: choosing a facility never opens resident records.
 */
import { route } from './route';
import { AITHORA_PREFIX } from './prefix';
import type { DirectoryRow } from '../facility-directory';

const A = AITHORA_PREFIX;

/** GET /facility-directory: Operator and Super Admin; 403 for everyone else. */
export const facilityDirectory = route<{ facilities: DirectoryRow[]; canEditRegions: boolean }>()('GET', `${A}/facility-directory`);
/** POST /facility-directory/:orgId/region: Super Admin only, audited. null clears back to the Census default. */
export const facilityRegionSet = route<{ ok: boolean; facility: DirectoryRow | null }, void, { region: string | null }>()(
  'POST', `${A}/facility-directory/:orgId/region`);
